import { render, staticRenderFns } from "./drugMsgContent.vue?vue&type=template&id=5807916f&scoped=true"
import script from "./drugMsgContent.vue?vue&type=script&lang=js"
export * from "./drugMsgContent.vue?vue&type=script&lang=js"
import style0 from "./drugMsgContent.vue?vue&type=style&index=0&id=5807916f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5807916f",
  null
  
)

export default component.exports